export async function stationIndexUseCase(stationRepository) {
    const result = await stationRepository.index();

    result.forEach(x => {
        x = new stationRepository.model(x);

        if (!x.isValid()) {
            throw new Error("station inválido");
        }
    })

    return result;
}